import { observer } from 'mobx-react';
import * as React from 'react';
import { Field, FieldLabel } from '../../../../web/components-v2/Field';
import { Input } from '../../../../web/components-v2/Input';
import { LeadRuleViewModel } from '../../../viewModels/leadrules';
import { styleSheet } from '../styles';

interface IProps {
	leadRule: LeadRuleViewModel;
}

export const BlitzNameFields: React.FC<IProps> = observer(({ leadRule }) => {
	const handlePublicName = (event: React.ChangeEvent<HTMLInputElement>) => leadRule?.setName(event.target.value);

	const handleBlitzName = (event: React.ChangeEvent<HTMLInputElement>) => leadRule?.setIdentifier(event.target.value);

	return (
		<>
			<Field styles={[styleSheet.field]}>
				<FieldLabel htmlFor='public-name-input'>Blitz Name</FieldLabel>
				<Input
					id='public-name-input'
					placeholder='Blitz Name'
					onChange={handlePublicName}
					type='text'
					value={leadRule?.name ?? ''}
				/>
			</Field>
			<Field styles={[styleSheet.field]}>
				<FieldLabel htmlFor='blitz-name-input'>Blitz ID</FieldLabel>
				<Input
					id='blitz-name-input'
					placeholder='Blitz ID'
					onChange={handleBlitzName}
					type='text'
					value={leadRule?.identifier ?? ''}
				/>
			</Field>
		</>
	);
});
